<template>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <websocketview />
    <router-view />
</template>

<script>
import websocketview from './socket.vue'
export default {
    name: 'App',
    components: {
        websocketview
    },
    mounted() {
        this.restictInspector();
    },
    methods: {
        restictInspector() {
            document.addEventListener("contextmenu", (event) => event.preventDefault());
            document.addEventListener("keydown", (event) => {
                if (
                    event.key === "F12" ||
                    (event.ctrlKey && event.shiftKey && event.key === "I") ||
                    (event.ctrlKey && event.shiftKey && event.key === "J") ||
                    (event.ctrlKey && event.key === "U")
                ) {
                    event.preventDefault();
                }
            });
            // setInterval(() => {
            //     const threshold = 160;
            //     if (window.outerWidth - window.innerWidth > threshold ||
            //         window.outerHeight - window.innerHeight > threshold) {
            //         alert("Developer tools detected! Access blocked.");
            //         this.$router.push({ name: 'Login' })
            //     }
            // }, 1000);
        }
    }
}
</script>

<style>
@import './styles/main.css';

::-webkit-scrollbar {
    width: 0.5em;
}

::-webkit-scrollbar-thumb {
    background: lightgrey;
    border-radius: 1em;
}

#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    display: grid;
}
</style>
